module.exports = __webpack_public_path__ + "static/media/honey-gift.cbd4dc08.jpg";